import { addHours, addMinutes, isValid, roundToNearestHours } from "date-fns";

export function getDefaultEventDates(now: Date = new Date()): { start: Date; end: Date } {
  const start = roundToNearestHours(addMinutes(now, 15), { roundingMethod: "ceil" });

  return { start, end: addHours(start, 1) };
}

/** Move an existing range without losing a duration the user has chosen. */
export function getEndDateAfterStartChange(
  start: Date | undefined,
  end: Date | undefined,
  nextStart: Date | undefined,
  defaultEnd: (start: Date) => Date,
): Date | undefined {
  if (!nextStart || !isValid(nextStart)) {
    return end;
  }

  if (start && end && isValid(start) && isValid(end) && end > start) {
    return new Date(nextStart.getTime() + end.getTime() - start.getTime());
  }

  // A start cleared and selected again should keep an independently chosen, valid end.
  if (!start && end && isValid(end) && end > nextStart) {
    return end;
  }

  return defaultEnd(nextStart);
}
